// import LocomotiveScroll from "locomotive-scroll";
// import anime from "animejs/lib/anime.es.js";

// var commonObject = {
//   asideBuildings: $(".js-aside-buildings"),
//   preloaderDuration: 1200
// };

var commonObject = {};

import FontFace from "../components/fontFace";
import NavHover from "../components/navHover";
import LazyLoad from "../components/lazyLoad";
import CopyLink from "../components/copyLink";
import Gallery from "../components/gallery";
import NavTrigger from "../components/navTrigger";
import NavScroll from "../components/navScroll";
import CookieNotice from "../components/cookieNotice";

require("svg4everybody")({
  polyfill: true, // Force inline SVG
});

export default {
  init() {
    // JavaScript to be fired on all pages

    this.reInit();
    // this.preload();
  },
  reInit() {
    // // $("body").addClass("-nav-open -popup-open");
    // $(".js-nav-trigger")
    //   .off()
    //   .on("click", function() {
    //     openAndCloseMenu();
    //   });

    // function openAndCloseMenu() {
    //   // console.log("hit");
    //   if ($("body").hasClass("-nav-open")) {
    //     // commonObject.scroll.start();
    //     $("body").addClass("-nav-closing");
    //     setTimeout(() => {
    //       $("body").removeClass("-nav-open -popup-open -nav-closing");
    //     }, 1500);
    //     $(".js-nav-trigger").removeClass("-is-open");
    //     $(".js-menu").removeClass("-is-open");
    //   } else {
    //     // commonObject.scroll.stop();
    //     $("body").addClass("-nav-open");
    //     $(".js-nav-trigger").addClass("-is-open");
    //     $(".js-menu").addClass("-is-open");
    //   }
    // }

    commonObject.fontFace = new FontFace().init();
    commonObject.navHover = new NavHover().init();
    commonObject.lazyLoad = new LazyLoad().init();
    commonObject.copyLink = new CopyLink().init();
    commonObject.gallery = new Gallery().init();
    commonObject.navTrigger = new NavTrigger().init();
    commonObject.navScroll = new NavScroll().init();

    if (!document.body.classList.contains("template-cookies")) {
      commonObject.cookieNotice = new CookieNotice(this);
    }

    require("svg4everybody")({
      polyfill: true, // Force inline SVG
    });

    document.body.classList.remove("js-stop-transition");

    // $(document).on("click", ".js-scroll-footer", () => {
    //   commonObject.scroll.scrollTo(document.querySelector("footer"));
    // });
  },
  finalize() {
    // function enablePlane() {
    //   anime({
    //     targets: ".js-location-plane svg",
    //     top: ["0%", "100%"],
    //     easing: "linear",
    //     duration: 1500
    //   });
    //   anime({
    //     targets: ".js-location-plane div",
    //     scaleY: [0, 1],
    //     easing: "linear",
    //     duration: 1500
    //   });
    // }
    // commonObject.scroll.on("call", t => {
    //   if (t === "location") {
    //     enablePlane();
    //   }
    // });
    // require("svg4everybody")({
    //   polyfill: true, // Force inline SVG
    // });
    // this.updateScrollbar();
  },
  getScrollbar() {
    // return commonObject.scroll;
  },
  updateScrollbar() {
    // commonObject.scroll.update();
  },
  preload() {
    // let tl = anime.timeline({
    //   duration: commonObject.preloaderDuration,
    //   easing: "linear"
    // });
    // let preloaderNumbers = {
    //   numbers: 0
    // };
    // tl.add({
    //   targets: ".js-preloader-line",
    //   scaleX: [0, 1],
    //   height: ["10px", "10px"],
    //   width: "100%",
    //   translateY: ["-50%", "-50%"]
    // });
    // tl.add(
    //   {
    //     targets: preloaderNumbers,
    //     numbers: 20,
    //     easing: "linear",
    //     round: 1,
    //     update: function() {
    //       $(".js-preloader-numbers").html(preloaderNumbers.numbers);
    //     }
    //   },
    //   0
    // );
    // tl.add(
    //   {
    //     targets: ".js-preloader-line",
    //     height: "100%",
    //     easing: "easeOutQuart"
    //   },
    //   "+=200"
    // );
    // tl.add({
    //   targets: ".js-preloader",
    //   opacity: 0,
    //   duration: 125,
    //   easing: "linear",
    //   complete: function() {
    //     $(".js-preloader").remove();
    //   }
    // });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js